import { render } from "./IconUnlink.vue?vue&type=template&id=09988e84"
import script from "./IconUnlink.vue?vue&type=script&lang=ts"
export * from "./IconUnlink.vue?vue&type=script&lang=ts"
script.render = render

export default script